<ng-container *ngIf="btnRaised; then mat_raised_button; else mat_button"></ng-container>

<ng-template #mat_button>
  <button
    mat-button
    [attr.data-testid]="testId"
    [id]="btnId"
    [attr.form]="btnForm"
    [type]="btnType"
    [disabled]="disabled"
    [ngClass]="btnClass"
    [color]="color">
    <div class="stacked-button">
      <span [ngClass]="{'no-show': showSpinner}">{{title}}</span>
      <mat-spinner diameter="20" color="accent" style="margin:auto" [ngClass]="{'no-show': !showSpinner}">
      </mat-spinner>
    </div>
  </button>
</ng-template>

<ng-template #mat_raised_button>
  <button
    mat-raised-button
    [attr.data-testid]="testId"
    [id]="btnId"
    [attr.form]="btnForm"
    [type]="btnType"
    [disabled]="disabled"
    [ngClass]="btnClass"
    [color]="color">
    <div class="stacked-button">
      <span [ngClass]="{'no-show': showSpinner}">{{title}}</span>
      <mat-spinner diameter="20" color="accent" style="margin:auto" [ngClass]="{'no-show': !showSpinner}">
      </mat-spinner>
    </div>
  </button>
</ng-template>
